module.exports = __webpack_public_path__ + "img/grade-G.724c559e.svg";